import { sdeSectionData } from './CardData';

// eslint-disable-next-line import/prefer-default-export
export function transformSdeSection(cardTitle, sdesList) {
  const sdeSections = [];
  const { sections } = sdeSectionData.filter((data) => data.cardTitle.includes(cardTitle)).pop();
  if (sdesList) {
    sections.forEach((section) => (
      sdeSections.push({
        sectionName: section.sectionName,
        sectionDescription: section.sectionDescription,
        attribute: sdesList.filter((attribute) => attribute.attribute.startsWith(section.prefix)),
        auth: section.auth,
        unauth: section.unauth,
      })
    ));
  }
  return sdeSections;
}
